import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const exit = yup
  .object({
    vehicle_id: yup.string().required(),
    command_type_constant: yup.string().required(),
    action: yup.string().required(),
  })
  .required();

export const ExitResolver = yupResolver(exit);
